interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex gap-3 mt-6 text-sm justify-center items-center">
      {page > 1 && (
        <>
          <button
            className="text-accent hover:underline bg-transparent border-none cursor-pointer font-mono text-sm p-0"
            onClick={() => onPageChange(page - 1)}
          >
            &laquo; Previous
          </button>
          <span className="text-muted">::</span>
        </>
      )}
      <span className="text-muted">
        Page {page} of {totalPages}
      </span>
      {page < totalPages && (
        <>
          <span className="text-muted">::</span>
          <button
            className="text-accent hover:underline bg-transparent border-none cursor-pointer font-mono text-sm p-0"
            onClick={() => onPageChange(page + 1)}
          >
            Next &raquo;
          </button>
        </>
      )}
    </div>
  );
}
